export const ADD_PACKAGE = 'savedPackages/ADD_PACKAGE';
export const REMOVE_PACKAGE = 'savedPackages/REMOVE_PACKAGE';
export const SET_PACKAGES = 'savedPackages/SET_PACKAGES';
